import React from 'react'
import { useForm } from 'react-hook-form'
import PrimaryButton from '../buttons/PrimaryButton'
import InputPrimary from '../forms/InputPrimary'
import { motion } from 'framer-motion'

const Step1 = ({ register, watch, errors, errorSignUp }) => {
  const allFields = watch(['email', 'password', 'passwordConfirmation'])
  const isFormFilled = allFields.every((field) => field && field.trim() !== '')

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="step2-container"
    >
      <p className="text-3xl text-primary font-bold text-center mb-6">
        Set up your profile
      </p>
      <p className="text-base font-normal text-center text-black mb-6">
        Your details help us customize your Purpose Quest and match you with
        relevant global challenges.
      </p>

      <div className="space-y-4">
        <div>
          <label htmlFor="email" className="font-bold mb-4">
            Email
          </label>
          <InputPrimary
            type="text"
            id="email"
            {...register('email', { required: 'Email is required' })}
            placeholder="Please enter your email"
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email.message}</p>
          )}
        </div>

        <div>
          <label htmlFor="password" className="font-bold mb-4">
            Password
          </label>
          <InputPrimary
            type="password"
            id="password"
            {...register('password', { required: 'Password is required' })}
            placeholder="Please enter your password"
          />
          {errors.password && (
            <p className="text-red-500 text-sm">{errors.password.message}</p>
          )}
        </div>

        <div>
          <label htmlFor="email" className="font-bold mb-4">
            Password Confirmation
          </label>
          <InputPrimary
            type="password"
            id="passwordConfirmation"
            {...register('passwordConfirmation', {
              required: 'Password confirmation is required',
            })}
            placeholder="Please enter your password"
          />
          {errors.passwordConfirmation && (
            <p className="text-red-500 text-sm">
              {errors.passwordConfirmation.message}
            </p>
          )}
        </div>

        {errorSignUp && (
          <p className="text-red-500 text-center my-4">{errorSignUp}</p>
        )}

        <PrimaryButton
          disabled={!isFormFilled}
          className="w-full"
          type="submit"
        >
          Continue
        </PrimaryButton>
      </div>
    </motion.div>
  )
}

export default Step1
